import * as R from 'ramda'

export const uniqueProperties: (propName: string) => (x0: any[]) => any = (propName: string) =>
  R.pipe(R.map(R.view(R.lensProp(propName))), R.uniq)
